<template>
  <b-modal
    :id="id"
    ok-title="บันทึก"
    ok-variant="success"
    cancel-title="ยกเลิก"
    title="เพิ่มรายชื่อนักศึกษาที่เข้าร่วมโครงการ"
    size="lg"
    :ok-disabled="$v.form.$anyError"
    @ok="submit"
    @hidden="resetModal"
    @cancel="resetModal"
    @show="setParticipantType"
  >
    <template>
      <table class="table table-borderless mb-3">
        <tr>
          <th width="200">รหัสนักศึกษา :</th>
          <td>
            <b-form-input id="student-id-input" v-model="$v.form.studentId.$model" :state="$v.form.studentId.$dirty ? !$v.form.studentId.$error : null" />
            <b-form-invalid-feedback id="student-id-input">
              กรุณากรอกเฉพาะตัวเลข
            </b-form-invalid-feedback>
          </td>
        </tr>
        <tr>
          <th width="200">ชื่อ - นามสกุล :</th>
          <td>
            <b-form-input v-model="$v.form.fullName.$model" :state="$v.form.fullName.$dirty ? !$v.form.fullName.$error : null" />
          </td>
        </tr>
        <tr>
          <th width="200">ประเภท :</th>
          <td class="align-middle">
            <b-form-group class="mb-0">
              <b-form-input
                id="input-expense"
                value="ผู้เข้าร่วมโครงการ (P)"
                readonly
              />
            </b-form-group>
            <p class="text-danger mt-3">*สามารถเพิ่มรายชื่อได้เฉพาะประเภท ผู้เข้าร่วมโครงการ(P) เท่านั้น </p>
          </td>
        </tr>
      </table>
    </template>
  </b-modal>
</template>

<script>
import gql from 'graphql-tag'
import { required, numeric } from 'vuelidate/lib/validators'

export default {
  props: {
    id: { type: String, required: true },
    projectId: { type: String, default: null }
  },
  data () {
    return {
      form: {
        fullName: '',
        studentId: '',
        type: null
      }
    }
  },
  validations: {
    form: {
      fullName: { required },
      studentId: { required, numeric },
      type: { required }
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }

      await this.$apollo.mutate({
        mutation: gql`mutation($id: ID!, $input: IndividualParticipantInput) { projectAddIndividualParticipant(id: $id, input: $input) { id } }`,
        variables: { id: this.$route.params.id, input: { fullName: this.form.fullName, studentId: this.form.studentId, type: this.form.type } }
      })
      this.$bvToast.toast('บันทึกรายชื่อผู้เข้าร่วมโครงการสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
      this.$bvModal.hide(this.id)
      this.$emit('finish')
    },
    resetModal () {
      this.form.fullName = ''
      this.form.studentId = ''
      this.form.studentId = null
      this.$v.form.$reset()
    },
    setParticipantType () {
      this.form.type = 'p'
    }
  }
}
</script>
